import SvgIcon from 'components/helpers/SvgIcon/SvgIcon';
import { useState, useRef, useEffect } from 'react';
import {
  RefinementList,
  RefinementListProps,
  useRefinementList,
} from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';

import { useSearchDictionary } from '../util';

const EventListingCategoryFacet = ({
  eventCategoryTitles,
  screenSize,
}: {
  eventCategoryTitles: string[];
  screenSize: 'desktop' | 'mobile';
}) => {
  const dict = useSearchDictionary();

  const [hideFilter, setHideFilter] = useState(false);

  const refinement = useRefinementList({ attribute: 'eventCategory' });

  const transformItems: RefinementListProps['transformItems'] = (items) => {
    let filteredItems;
    if (eventCategoryTitles === undefined || eventCategoryTitles.length === 0) {
      filteredItems = items;
    } else {
      filteredItems = items.filter((item) => eventCategoryTitles?.includes(item.value));
    }
    return filteredItems;
  };

  // setting Hide Filter in useEffect instead of transform to prevent React error for updating state at the wrong time
  useEffect(() => {
    const filteredItems = transformItems(refinement.items, {});
    setHideFilter(filteredItems.length === 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refinement.items]);

  const dropDownRef = useRef<HTMLDetailsElement>(null);

  const handleDropDownClickAway = (e: Event) => {
    // Close it if element exists and we did not click inside
    if (dropDownRef.current && !dropDownRef.current.contains(e.target as Node)) {
      // Details element has an internal toggle that behaves oddly with React so using native functionality
      dropDownRef.current.open = false;
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', handleDropDownClickAway);

    return () => document.body.removeEventListener('click', handleDropDownClickAway);
  }, []);

  return (
    <div className={classnames({ hidden: hideFilter })}>
      {screenSize === 'desktop' ? (
        <details className={classnames('relative', 'mr-20')} ref={dropDownRef}>
          <summary
            className={classnames(
              'relative',
              'bg-white',
              'border',
              'border-gray-spunPearl',
              'rounded-md',
              'p-2',
              'w-full',
              'flex',
              'items-center',
              'justify-between'
            )}
          >
            <span>{dict.eventCategory}</span>
            <span>
              <SvgIcon
                icon="chevron-down"
                size="xs"
                viewBoxSize="0 0 24 24"
                className={classnames('mr-2')}
              />
            </span>
          </summary>
          <div
            className={classnames(
              'absolute',
              'z-20',
              'p-6',
              'bg-white',
              'border',
              'border-gray-spunPearl',
              'rounded-md',
              'p-2',
              'w-full'
            )}
          >
            <RefinementList attribute="eventCategory" sortBy={['name:asc']} />
          </div>
        </details>
      ) : (
        <>
          <hr className={classnames('my-6')} />
          <h3 className={classnames('text-blue-navy', 'heading-sm', 'mb-6')}>
            {dict.eventCategory}
          </h3>
          <RefinementList attribute="eventCategory" sortBy={['name:asc']} />
        </>
      )}
    </div>
  );
};

export default EventListingCategoryFacet;
